import React from "react";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-white text-gray-800 text-center">
      <h1 className="text-9xl font-extrabold tracking-wide text-gray-900">404</h1>
      <p className="text-2xl font-semibold mt-4 text-gray-800">Oops! Page not found.</p>
      <p className="text-lg mt-2 max-w-lg text-gray-600">
        The page you are looking for doesn't exist or has been moved. Let's get you back home!
      </p>
      <button
        onClick={() => navigate("/")}
        className="mt-6 px-6 py-3 bg-blue-600 text-white font-bold rounded-lg shadow-sm hover:bg-blue-700 transition-colors"
      >
        Go to Home
      </button>
      <div className="absolute bottom-10 text-gray-400 text-sm">
        <p> {new Date().getFullYear()} Elitex. All rights reserved.</p>
      </div>
    </div>
  );
};

export default NotFound;